import { supabase } from '@/lib/supabase';

export interface ModuleMatrixRow {
  organization_id: string;
  org_name: string;
  module_key: string;
  label_he: string | null;
  label_en: string | null;
  is_active: boolean;
}

export const modulesApi = {
  /**
   * Cross-org modules matrix (orgs × modules). Backed by the SECURITY DEFINER
   * RPC `admin_org_modules_matrix`, which is guarded to platform admins.
   */
  getModulesMatrix: async (): Promise<ModuleMatrixRow[]> => {
    const { data, error } = await supabase.rpc('admin_org_modules_matrix');
    if (error) throw error;
    return (data ?? []) as ModuleMatrixRow[];
  },
};
